export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: '戻る',
            backToProject: 'ホームに戻る',
            defaultTitle: '無題のドキュメント',
            editTitle: 'クリックしてタイトルを編集',
            clickToEditName: 'クリックして編集',
            screen: {
                single: 'シングル画面',
                split: '分割画面',
            },
            aiHiro: 'AI Chat',
            save: '保存',
            saveOptions: '保存オプション',
            saveToFolder: 'フォルダに保存',
            saveSuccess: '保存が成功しました',
            saveFailed: '保存に失敗しました',
            export: 'エクスポート',
            share: '共有',
            sharePermissionDenied: 'プロジェクトの作成者のみが共有できます',
            updateTitleSuccess: 'タイトルが正常に更新されました',
            updateTitleFailed: 'タイトルの更新に失敗しました',
            importing: 'ドキュメントをインポート中...',
            importSuccess: 'インポートが成功しました',
            importFailed: 'インポートに失敗しました',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: 'ソースを追加',
            createDocument: 'ドキュメントを作成',
            selectDocumentType: 'ドキュメントタイプを選択して作成',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: '空白ドキュメント',
            placeholder: '空白ドキュメントを作成',
            title: '空白ドキュメント',
            description: '空のドキュメントを作成し、ゼロから執筆を開始',
            action: '空白ドキュメントを作成',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: '他のタブを閉じる',
            closeAll: 'すべて閉じる',
            files: 'ファイル',
            originalText: '原文',
        },
    },
};
